import ArchiveModule from '../components/ArchiveModule.jsx'
import ReactDOM from 'react-dom'
import React from 'react'

window.ArchiveModule = {
  el: null,
  options: {},
  render: function(el, options){
    _.extend(this.options, options)
    this.el = el
    ReactDOM.render(React.createElement(ArchiveModule, options), document.getElementById(this.el))
  },
  unmount: function(){
    if(this.el) ReactDOM.unmountComponentAtNode(document.getElementById(this.el))
    this.el = null
  }
}



// WEBPACK FOOTER //
// ./src/external/ArchiveModule.jsx